import { render, staticRenderFns } from "./CalendarNavMonth.vue?vue&type=template&id=2bb0d96a"
import script from "./CalendarNavMonth.vue?vue&type=script&lang=js"
export * from "./CalendarNavMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports